import React from 'react';
import { FormControlLabel, Radio, TextField, Grid } from '@material-ui/core';
import { useCallback } from 'react';
import { $gt, $lt, $lte, $gte, $bw } from '../operators';
import { FilterForm, useFilterFormActions } from './filter-form';
import { mergeOverride } from './override-operator';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file

export const NumberFilters = props => (
  <FilterForm {...props} radioFilters={NumberFilterFormItems} />
);

export function NumberFilterFormItems({ radioValue, setRadioFilter, column }) {
  const { handleInputClick, form, getRadioValue, getRadioFilterSetter } = useFilterFormActions(
    radioValue,
    setRadioFilter
  );

  const handleRangeInputClick = useCallback((event: React.MouseEvent<HTMLInputElement>) => {
    const input = event.target as HTMLInputElement;
    if (getRadioValue() !== $bw.key) {
      getRadioFilterSetter()($bw.key);
      setTimeout(() => input.focus());
    }
  }, []);

  return (
    <>
      <FormControlLabel
        value={$bw.key}
        control={<Radio />}
        label={
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <TextField
                onClick={handleRangeInputClick}
                inputRef={form.register}
                required
                name={`${$bw.key}[0]`}
                disabled={getRadioValue() !== $bw.key}
                variant="outlined"
                size="small"
                label="From"
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                required
                onClick={handleRangeInputClick}
                inputRef={form.register}
                name={`${$bw.key}[1]`}
                disabled={getRadioValue() !== $bw.key}
                variant="outlined"
                size="small"
                label="To"
              />
            </Grid>
          </Grid>
        }
      />
      <br />
      {[$gt, $lt, $lte, $gte].map(mergeOverride(column.overrideOperator)).map(e => (
        <React.Fragment key={e.key}>
          <FormControlLabel
            value={e.key}
            control={<Radio />}
            label={
              <TextField
                onClick={handleInputClick}
                inputRef={form.register}
                name={e.key}
                disabled={getRadioValue() !== e.key}
                variant="outlined"
                type="number"
                size="small"
                label={e.label}
              />
            }
          />
          <br />
        </React.Fragment>
      ))}
    </>
  );
}
